// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"436":"11218097","453":"d6472197"}[chunkId] + ".chunk.js";
};